// extracted by mini-css-extract-plugin
export var bisolnatur = "styles-module--bisolnatur--7CHLM";
export var breadcrumb = "styles-module--breadcrumb--Z9Ndh";
export var content = "styles-module--content--E4+uR";
export var filter = "styles-module--filter--cZTze";
export var header = "styles-module--header--DmJ42";
export var holder = "styles-module--holder--CoDwW";
export var image = "styles-module--image--Bvg-I";
export var productHolder = "styles-module--productHolder--EzZqU";
export var whatHolder = "styles-module--whatHolder--a98JS";